import * as React from 'react';
const dashboard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g transform="translate(-67.001 -154)">
        <path
          d="M2.844,7.529H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H5.53a2,2,0,0,1,2,2v.844A5.166,5.166,0,0,0,2.845,7.528Z"
          transform="translate(67 154)"
          fill="#fff"
          opacity="0.6"
        />
        <path
          d="M5.53,7.529H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0h.844A5.166,5.166,0,0,0,7.53,4.684v.845A2,2,0,0,1,5.53,7.529Z"
          transform="translate(67 162.471)"
          fill="#fff"
          opacity="0.6"
        />
        <path
          d="M5.53,7.529H4.684A5.167,5.167,0,0,0,0,2.845V2A2,2,0,0,1,2,0H5.53a2,2,0,0,1,2,2V5.53A2,2,0,0,1,5.53,7.529Z"
          transform="translate(75.471 154)"
          fill="#fff"
          opacity="0.6"
        />
        <path
          d="M5.53,7.529H2a2,2,0,0,1-2-2V4.684A5.166,5.166,0,0,0,4.684,0H5.53a2,2,0,0,1,2,2V5.529A2,2,0,0,1,5.53,7.529Z"
          transform="translate(75.471 162.471)"
          fill="#fff"
          opacity="0.6"
        />
      </g>
    </svg>
  );
};

export default dashboard;
